module.exports = __webpack_public_path__ + "static/dis_cease-912240b0f11f892a2d48ff8e2a4bde3c.png";